module.exports = __webpack_public_path__ + "static/media/testimony1.0d3f6cab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/testimony1.jpg
// module id = 275
// module chunks = 0